export const linenFaqs = [
  {
    question: "What is a linen management system?",
    answer:
      "An IoT and RFID-based platform that tracks every linen item — from sheets and towels to scrubs and gowns — across its entire lifecycle: storage, distribution, use, laundry, and replacement.",
  },
  {
    question: "Who uses linen management systems?",
    answer:
      "Hospitals, care homes, hotels, central laundries, and large facilities with thousands of textile items in rotation.",
  },
  {
    question: "What real-time data does the system provide?",
    answer:
      "Live counts per location, item-level wash cycle history, loss-detection alerts, and usage analytics that flag over- or under-stocking.",
  },
  {
    question: "How is this different from your order management platform?",
    answer:
      "Order management handles purchasing and procurement; linen management handles the operational lifecycle of items already in your facility. The two integrate.",
  },
];
